module.exports = __webpack_public_path__ + "static/media/map.c8f6849d.png";